<template>
  <div :id="id" class="learning-page-hero">
    <div class="learning-page-hero__container container">
      <div class="learning-page-hero__content">
        <h1 class="learning-page-hero__headline" v-html="headline" />
        <div class="learning-page-hero__subheadline" v-html="subheadline" />
        <div class="learning-page-hero__footer">
          <button-vue
            :href="href"
            :class="{
              'learning-page-hero__cta': true,
              'learning-page-hero__cta--placeholder': cta === '&nbsp;'
            }"
            event-category="body-20200416-life_fit_learning_hero"
            :open-signup="openSignup"
          >
            <span v-html="cta" />
          </button-vue>
        </div>
      </div>
      <wave-hero />
    </div>
  </div>
</template>

<script>
import globals from "@/utils/globals"
import ButtonVue from "@/shared/button"
import WaveHero from "shared/wave-image/hero"

export default {
  name: "LearningPageHero",
  components: {
    WaveHero,
    ButtonVue
  },
  onboardingPath: globals.onboardingPath,
  props: {
    id: { type: String, default: "learning_page_hero" },
    headline: { type: String, default: null },
    subheadline: { type: String, default: null },
    cta: { type: String, default: null },
    href: { type: String, default: "#" },
    openSignup: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss">
.learning-page-hero {
  @include font-family(sans-serif);

  overflow: hidden;

  &__container {
    @include grid-css;
  }

  &__content {
    @include grid-css-element(12);

    position: relative;
    z-index: 2;

    padding-top: $padding-top-section-hero-xs;
    padding-bottom: $padding-section-xs;

    @include media(min-width, m) {
      @include grid-css-element(6);

      padding-top: $padding-top-section-hero-m;
      padding-bottom: $padding-section-m;
    }

    @include media(min-width, l) {
      @include grid-css-element(6);

      padding-top: $padding-section-l;
      padding-bottom: $padding-section-l;
    }
  }

  &__headline {
    @include h1;

    margin-bottom: $spacing-24;

    @include media(min-width, m) {
      margin-bottom: $spacing-32;
    }
  }

  &__subheadline {
    @include p0($color: $deep-black);

    margin-bottom: $spacing-24;

    > * {
      color: inherit;
      font-size: inherit;
      line-height: inherit;

      &:last-child {
        margin-bottom: 0;
      }
    }

    @include media(min-width, m) {
      margin-bottom: $spacing-32;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;

    @include media(min-width, m) {
      justify-content: flex-start;
    }

    @include media(min-width, l) {
      @include grid-css(6);
    }
  }

  &__cta {
    @include button-block-modifier;

    &--placeholder {
      visibility: hidden;
    }

    @include media(min-width, l) {
      @include grid-css-element(4);
    }
  }
}
</style>
